var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-scr"},[_c('vue-element-loading',{attrs:{"active":_vm.loading,"is-full-screen":true,"text":_vm.loadingText,"size":"45","spinner":"bar-fade-scale","color":"#14899b"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }